import type { Filter } from '@/app/common/filters/core/filtersTypes.ts';
import { urlParamOf } from '@/app/common/filters/core/filterDefinitions.ts';
import type {
  ResultPageFilterTracking,
  RESULT_PAGE_FILTER_TRIGGER_SECTION,
  RESULT_PAGE_FILTER_TYPE,
} from '@/app/common/starTrack/events/resultPageFilter.ts';

// A chip toggles one filter; remember it by the URL param that filter writes, which is how the
// RESULT_PAGE_FILTER event identifies the filter it reports.
export const highlightedTracking = (
  triggerSection: RESULT_PAGE_FILTER_TRIGGER_SECTION,
  filter: Filter,
  filterType: RESULT_PAGE_FILTER_TYPE
): ResultPageFilterTracking => {
  const urlParam = urlParamOf(filter.name);
  return { triggerSection, highlighted: urlParam ? { [urlParam]: filterType } : {} };
};
